module.exports = __webpack_public_path__ + "static/media/ehealth_latest_news_banner_mobile.e5221299.jpg";